import React, { useEffect, useState } from "react";
import './Navbar.css';
import { getSession, logOut } from "../../../features/redux/sessionSlice";
import { useDispatch, useSelector } from "react-redux";
import { getMyOfficesAsync, getOfficeActiveSessionsAsync, getMyOffices, getOfficeSessions, getLoadingMyOffices, getLoadingOfficeSessions, setCurrentSessionId } from "../../../features/redux/appSlice";
import { useNavigate } from "react-router-dom";

function Navbar() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const offices = useSelector(getMyOffices);
    const officeSessions = useSelector(getOfficeSessions);
    const isLoadingOffices = useSelector(getLoadingMyOffices);
    const isLoadingSessions = useSelector(getLoadingOfficeSessions);
    const [officesOpen, setOfficesOpen] = useState(false);
    const [currentOffice, setCurrentOffice] = useState(null);
    const currentSession = useSelector(getSession);

    useEffect(() => {
        dispatch(getMyOfficesAsync());
    }, [dispatch]);

    const handleOfficeSelect = (office) => {
        setCurrentOffice(office);
        dispatch(setCurrentSessionId(office.id));
        setOfficesOpen(false);
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <div className="dropdown">
                    <button disabled={isLoadingOffices} className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" onClick={() => { setOfficesOpen(!officesOpen) }}>
                        {(currentOffice || {}).name || 'Select Office'}
                    </button>
                    <div className="dropdown-menu" style={{ display: officesOpen ? 'block' : 'none' }}>
                        {offices.map((office, index) => (
                            <a key={'office-' + index} className="dropdown-item" onClick={() => handleOfficeSelect(office)} href="#">{office.name}</a>
                        ))}
                    </div>
                </div>
                <div className="btn-group btn-group-toggle" data-toggle="buttons">
                    {currentSession.admin && (
                        <button className="btn btn-outline-success my-2 my-sm-0" onClick={() => { navigate('/admin-dashboard') }} type="submit">Admin</button>
                    )}
                    <button className="btn btn-outline-danger my-2 my-sm-0" onClick={() => { dispatch(logOut()) }} type="submit">Log Out</button>
                </div>
            </div>
           
        </nav>
    );
}

export default Navbar;
